export default "__VITE_ASSET__be2cf7ec__"